import { from, Observable, of } from "rxjs";
import { apiClient } from "./api";
import { ENDPOINTS } from "@/settings/api-settings";
import { map } from "rxjs/operators";

export function findAddressByCep(cep): Observable<any> {
  return from(
    apiClient.get(`${ENDPOINTS.ADDRESS_CEP}/${cep}`),
  ).pipe(map((r: any) => r.data || {}));
}

export function listCitiesByUf(uf): Observable<Array<any>> {
  if (!uf) {
    return of([]);
  }
  return from(apiClient.get(ENDPOINTS.ADDRESS_CITIES.replace('{uf}', uf))).pipe(
    map((r: any) => {
      return r.data;
    }),
  );
}